<div class="form-check">
  <label>
    <input
      type="checkbox"
      class="form-check-input"
      (change)="onConsentChange()"
      [checked]="consentGiven"
      [name]="consentTemplate.id"
      [disabled]="disabled || isRequired(consentTemplate?.id)"
    />
    <span class="form-check-label cx-be-bold">
      <ng-container *ngIf="consentTemplate?.name">
        {{ consentTemplate?.name }}
        <br />
      </ng-container>
    </span>
    <span
      *cxFeature="'!a11yNotificationsOnConsentChange'"
      class="form-check-label"
    >
      {{ consentTemplate?.description }}
      <ng-template [ngTemplateOutlet]="requiredAsterisk"></ng-template>
    </span>
  </label>
  <span
    *cxFeature="'a11yNotificationsOnConsentChange'"
    class="form-check-label"
  >
    {{ consentTemplate?.description }}
    <ng-template [ngTemplateOutlet]="requiredAsterisk"></ng-template>
  </span>
</div>

<ng-template #requiredAsterisk>
  <ng-container *ngIf="showMandatory">
    <abbr
      *cxFeature="'a11yRequiredAsterisks'"
      aria-hidden="true"
      class="text-decoration-none required-asterisk"
      title="{{ 'common.required' | cxTranslate }}"
      >*</abbr
    >
  </ng-container>
</ng-template>
